import { useState, useEffect } from 'react';
import { getModelsPublished } from 'services/analytics';
import { useDispatch } from 'react-redux';
import { showError } from '../../../../../redux/common/actions';
import { SHOW_ALL_OPTION } from '../../constants';

export const useModels = (departmentValue, showAll = true) => {
  const dispatch = useDispatch();
  const [models, setModels] = useState([]);

  useEffect(() => {
    const loadModels = async () => {
      try {
        // Handle both single department and multi-select departments
        let siteDepartmentId = "";
        let siteDepartmentIds = [];

        if (Array.isArray(departmentValue)) {
          // Multi-select: extract IDs from array of objects
          siteDepartmentIds = departmentValue
            .filter(dept => dept?.id && dept.id !== '' && dept.id !== 'all')
            .map(dept => dept.id);
        } else if (departmentValue?.id && departmentValue.id !== '' && departmentValue.id !== 'all') {
          // Single select: use the ID directly
          siteDepartmentId = departmentValue.id;
        }

        const response = await getModelsPublished({
          siteDepartmentId,
          siteDepartmentIds
        });
        if (response?.status) {
          const fetchedModels = response.data || [];
          const formattedModels = fetchedModels.map(m => ({
            ...m,
            name: `${m.name} ${m.modelName || ''}`
          }));

          // Conditionally add 'Show All' based on showAll flag and if models exist
          const updatedModels = (showAll && formattedModels.length > 0)
            ? [SHOW_ALL_OPTION, ...formattedModels]
            : formattedModels;
          setModels(updatedModels);
        }
      } catch (error) {
        dispatch(showError('Failed to load models'));
      }
    };
    loadModels();
  }, [JSON.stringify(departmentValue)]);

  return models;
}; 